import React from 'react';
import YouTube from 'react-youtube';
import styled from 'styled-components';
import { Box } from 'dma-ui-kit';

const Container = styled(Box)`
  padding: 0 12px;

  @media (min-width: 768px) {
      padding: 0 24px;
  }

  @media (min-width: 1024px) {
      padding: 0 48px;
  }    

  max-width: 1250px;
  margin-bottom: 10px;
  display: block;
`;

const VideoWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    margin: 0 auto;
    
    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;

const YoutubeVideo = props => {
    const { attributes } = props.paragraph;

    const opts = {
        width: '100%',
        height: '100%',
        playerVars: {
            autoplay: 0,
            playsinline: 0,
        },
    };

    const { field_video_id } = attributes;

    return (
        <Container>
            <VideoWrapper>
                <YouTube videoId={field_video_id} opts={opts} />
            </VideoWrapper>
        </Container>
    );
};

export default YoutubeVideo;